module.exports = __webpack_public_path__ + "static/media/book4cover_preview.f3e68e4f.png";